import '../../style';
import './index.less';



// WEBPACK FOOTER //
// ./components/input-key-board/style/index.tsx